import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import TextareaAutosize from "@mui/base/TextareaAutosize";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import "./IssueModal.scss";
import { useEffect, useState } from "react";
import moment from "moment/moment";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { errorToast, successToast } from "../../common/ToastMessage";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import dayjs from 'dayjs';
import Loader from "../../common/Loader";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function IssueModal({
  open,
  close,
  viewissuedata,
  issueacceptid,
  disableField,
  getissueDetails,
  getAcceptDetails,
  getRejectedIssue,
}) {
  const navigate = useNavigate()
  const [time, setTime] = React.useState();
  const [employeeName, setemployeeName] = useState("");
  const [date, setDate] = useState("");
  const [applianceCode, setApplianceCode] = useState("");
  const [assignProjectName, setAssignProjectName] = useState("");
  const [issueDescription, setIssueDescription] = useState("");
  const [accept, setAccept] = useState(true);
  const [reject, setReject] = useState(true);
  const [showBtns, setShowBtns] = useState(false);
  const [brands, setBrands] = useState();
  const [value, setValue] = useState(new Date());
  const [resolvedDateTIme, setResolvedDateTIme] = useState(moment().format('dddd, MMMM DD YYYY, h:mm:ss a'));
  const [appliances, setAppliances] = useState([]);
  const [error, setError] = useState([]);
  const [reply, setReply] = useState("");
  const [isActive, setLoaderActive] = useState(false);

  useEffect(() => {
    setemployeeName(viewissuedata?.employeeName);
    setDate(viewissuedata?.date);
    setAssignProjectName(viewissuedata?.assignProjectName);
    setApplianceCode(viewissuedata?.applianceCode);
    setIssueDescription(viewissuedata?.issueDescription);
    getBrandName()
    getApliances()
  }, []);

  const validateForm = () => {
    setError([]);
    let error = {};

    // if (!accept ? !time : reject) {
    //   error.time = "Time is required";
    // }
    if (!reply) {
      error.reply = "Reply is required";
    }
    if (Object.keys(error).length > 0) {
      setError(error);
      return false;
    }
    return true;
  };


  const getacceptissue = async () => {
    if (validateForm()) {
      const headers = {
        Authorization: "Bearer " + localStorage.getItem("_token"),
        "Content-type": "application/json",
      };
      setLoaderActive(true);
      try {
        let payload = {
          "resolveTime": resolvedDateTIme,
          "adminResponse": reply,
          "time_Date": moment(value).format('YYYY-MM-DDTHH:mm:ss'),
        }
        axios.post(
          `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Issue/UpdateAccept?id=${issueacceptid}`,
          payload,
          {
            headers: headers,
          }
        ).then((response) => {
          if (response.status === 400) {
            navigate("/issueaccept");
            setLoaderActive(false);
          }
          if (response.status === 200) {
            close();
            setLoaderActive(false);
            successToast(response?.data?.message)
            getissueDetails();
          }
        });

      } catch (error) {
        console.log(error);
        setLoaderActive(false);
        if (error?.response?.status === 401) {
          errorToast(error?.response?.statusText)
        } else {
          errorToast(error?.message)
        }
      }
    }
    // setAccept(true)
  };

  const getrejectissue = async () => {
    if (validateForm()) {
      const headers = {
        Authorization: "Bearer " + localStorage.getItem("_token"),
        "Content-type": "application/json",
      };
      setLoaderActive(true);
      try {
        let payload = {
          "id": issueacceptid,
          "adminResponse": reply
        }
        axios.post(
          `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Issue/UpdateReject?id=${issueacceptid}`,
          payload,
          {
            headers: headers,
          }
        ).then((response) => {
          if (response.status === 200) {
            close();
            successToast(response?.data?.message)
            getissueDetails();
            setLoaderActive(false);
          }
          if (response.status === 400) {
            navigate("/issuerejected");
          }
        });

      } catch (error) {
        console.log(error);
        setLoaderActive(false);
        if (error?.response?.status === 401) {
          errorToast(error?.response?.statusText)
        } else {
          errorToast(error?.message)
        }
      }
    }
  };
  const getBrandName = async () => {
    const headers = {
      Authorization: "Bearer " + localStorage.getItem("_token"),
      "Content-type": "application/json",
    };
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Appliance/GetBrandName`,
        {
          headers: headers,
        }
      );

      if (response.status === 400) {
        navigate("/login");
      }
      setBrands(response.data.data);
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 401) {
        errorToast(error?.response?.statusText)
      } else {
        errorToast(error?.message)
      }
    }
  };
  const getApliances = async () => {
    const headers = {
      Authorization: "Bearer " + localStorage.getItem("_token"),
      "Content-type": "application/json",
    };
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Appliance`,
        {
          headers: headers,
        }
      );
      if (response.status === 400) {
        navigate("/login");
      }
      setAppliances(response.data.data);
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 401) {
        errorToast(error?.response?.statusText)
      } else {
        errorToast(error?.message)
      }
    }
  };

  function getDisabledHours() {
    var hours = [];
    for (let i = 0; i < moment().hour(); i++) {
      hours.push(i);
    }
    return hours;
  }

  const handleChange = (newValue) => {
    setValue(dayjs(newValue).format());
    setResolvedDateTIme(dayjs(newValue).format('dddd, MMMM DD YYYY, h:mm:ss a'))

  };
  return (
    <div>
      <Loader isLoading={isActive} />
      {open ? (
        <BootstrapDialog
          className="issue-modal-wrap modal-wrap"
          onClose={() => close()}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={() => close()}
          >
            Pending Issue
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <div className="row">
              <div className="col-md-12">
                <div className="txtfield-wrap">
                  <TextField
                    id="outlined-required"
                    fullWidth
                    label="Employee Name"
                    defaultValue={viewissuedata?.employeeName}
                    value={employeeName ? employeeName : ""}
                    disabled={disableField ? false : true}
                  />
                </div>
              </div>
              <div className="col-md-6">
                {viewissuedata?.applianceCode?.map((itm, index) => (
                  <div className="txtfield-wrap" key={`appliance-names-${index + 1}`}>
                    <div>
                      <FormControl fullWidth>
                        <InputLabel
                          id="demo-simple-select-label"
                        >
                          {index == 0 ? 'Appliance Name' : `Appliance Name ${index}`}
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={itm}
                          label="Appliances Name"
                          disabled
                        >
                          {appliances &&
                            appliances.map((item, index) => {
                              return (
                                <MenuItem value={item?.applianceId}
                                  key={`appliance-view${index + 1}`}
                                >
                                  {item?.applianceCode}
                                </MenuItem>
                              );
                            })}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                ))}
              </div>
              <div className="col-md-6">
                {viewissuedata?.brandName?.map((itm, index) => (
                  <div className="txtfield-wrap" key={`brand-names-${index + 1}`}>
                    <FormControl fullWidth>
                      <InputLabel
                        id="demo-simple-select-label"
                      >
                        {index == 0 ? 'Brand Name' : `Brand Name ${index}`}
                      </InputLabel>

                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={itm}
                        label="Brand Name"
                        disabled={disableField ? false : true}
                      >
                        {brands &&
                          brands.map((item, index) => {
                            return (
                              <MenuItem value={item?.brandId}
                                key={`brand-view${index + 1}`}
                              >
                                {item?.brandName}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl>
                  </div>
                ))}
              </div>
              <div className="col-md-6">
                <div className="txtfield-wrap">
                  <TextField
                    id="outlined-required"
                    fullWidth
                    label="Created Date"
                    value={date ? moment(viewissuedata?.date).format(
                      "DD/MM/YYYY"
                    ) : ""}
                    defaultValue={moment(viewissuedata?.date).format(
                      "DD/MM/YYYY"
                    )}
                    disabled={disableField ? false : true}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="txtfield-wrap">
                  <TextField
                    id="outlined-required"
                    fullWidth
                    label="Assigned Project"
                    defaultValue={viewissuedata?.assignProjectName}
                    value={assignProjectName ? assignProjectName : ""}
                    disabled={disableField ? false : true}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="txtfield-wrap">
                  <TextareaAutosize
                    aria-label="empty textarea"
                    label="Issue Description"
                    placeholder="please check working properly..."
                    minRows={5}
                    style={{ width: "100%" }}
                    defaultValue={viewissuedata?.issueDescription}
                    value={issueDescription ? issueDescription : ""}
                    disabled={disableField ? false : true}
                  />
                </div>
              </div>
            </div>
          </DialogContent>
          <>
            <DialogActions className="btns-wrapper-issue">
              <Stack spacing={4} direction="row" className="bottom-btn-wrap">
                <>
                  {!showBtns && <Button
                    color="success"
                    style={{ height: '40px', width: '80px', borderRadius: '30px', margin: '8px', padding: '8px' }}
                    variant="contained"
                    type="button"
                    onClick={() => {
                      setShowBtns(true)
                      setAccept(false);
                    }}
                  >
                    Accept
                  </Button>}
                  {!showBtns && reject && <Button
                    variant="contained"
                    style={{ height: '40px', width: '80px', borderRadius: '30px', margin: '8px', padding: '8px' }}
                    color="error"
                    type="button"
                    onClick={() => {
                      setShowBtns(true)
                      setReject(false);
                    }}
                  >
                    Reject
                  </Button>}

                  {showBtns ?
                    <>
                      {!accept &&
                        <FormControl >
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Stack spacing={2} style={{ width: '200px', margin: '3px', padding: '3px', display: 'flex' }} >
                              <DesktopDatePicker
                                label="Date "
                                inputFormat="DD/MM/YYYY"
                                value={value}
                                minDate={new Date()}
                                onChange={handleChange}
                                renderInput={(params) => <TextField {...params} />}
                              />
                              <TimePicker
                                label="Time"
                                value={value}
                                onChange={handleChange}
                                // disabledHours={  getDisabledHours() }
                                renderInput={(params) => <TextField {...params} />}
                              // minTime={moment()}
                              />
                              {/* <DateTimePicker
                                label="Date&Time picker"
                                value={value}
                                onChange={handleChange}
                                renderInput={(params) => <TextField {...params} />}
                              /> */}
                            </Stack>
                          </LocalizationProvider>
                          {/* {error.time !== "" && (
                            <div style={{ color: "red" }}>{error.time}</div>
                          )} */}
                        </FormControl>
                      }
                      <FormControl  >
                        <TextareaAutosize
                          aria-label="Empty textarea"
                          placeholder="Reply to Employee"
                          minRows={2}
                          onChange={(e) => { setError([]); setReply(e.target.value) }}
                          style={{ width: '220px', margin: '8px', padding: '8px', borderRadius: '2px', ...error && error.reply ? { border: '1px solid red' } : {} }}
                          error={error && error.reply}
                        />
                        {error.reply !== "" && (
                          <div style={{
                            color: "red"
                          }}>{error.reply}</div>
                        )}
                      </FormControl>
                    </> : null
                  }
                  {showBtns && <Button
                    variant="contained"
                    style={{ backgroundColor: '#002138', color: ' #fff', height: '40px', width: '80px', borderRadius: '30px', margin: '8px', padding: '8px' }}
                    type="button"
                    onClick={() => { !accept ? getacceptissue() : getrejectissue() }}
                  >
                    Send
                  </Button>}
                  <Button
                    variant="contained"
                    style={{ backgroundColor: '#002138', color: ' #fff', height: '40px', width: '80px', borderRadius: '30px', margin: '8px', padding: '8px' }}
                    type="button"
                    onClick={() => {
                      close();
                    }}
                  >
                    Cancel
                  </Button>
                </>
              </Stack>
            </DialogActions>
          </>
        </BootstrapDialog>
      ) : null}
    </div>
  );
}
